module.exports = __webpack_public_path__ + "static/media/recordista_o.6ee149ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/badges/recordista_o.png
// module id = 1171
// module chunks = 0